export default __webpack_public_path__ + "static/organization-a1a00a8f5b380fbccd3e267c0dfab877.webp";